module.exports = __webpack_public_path__ + "static/media/icon-ro.8f2e76a4.svg";